import { BaseProviderInstanceResourceModel } from './base-provider-instance-resource-model';

export class ChangeResultItem<A> {
  previous: A;
  current: A;
}
